document.addEventListener('click', function(e) {
    const swatch = e.target.closest('.color-swatch--custom');

    if (!swatch || swatch.classList.contains('color-swatch--more')) {
        return;
    }

    e.preventDefault();

    const card = swatch.closest('.grid__item');
    if (!card) return;

    const mainImg = card.querySelector('.grid-product__image-mask img');
    const secondaryImg = card.querySelector('.grid-product__secondary-image img');

    const newMainImage = swatch.dataset.mainImage;
    const newSecondaryImage = swatch.dataset.secondaryImage;

    if (mainImg && newMainImage) {
        mainImg.src = newMainImage;
        mainImg.removeAttribute('srcset');
    }

    if (secondaryImg && newSecondaryImage) {
        secondaryImg.src = newSecondaryImage;
        secondaryImg.removeAttribute('srcset');
    }

    card.querySelectorAll('.color-swatch--custom.active').forEach(el => {
        el.classList.remove('active');
    });

    swatch.classList.add('active');

    const link = card.querySelector('.grid-product__link');
    const title = card.querySelector('.grid-product__title');

    if (link) {
        link.href = swatch.dataset.productUrl;
    }

    if (title) {
        title.textContent = swatch.dataset.productTitle;
    }
});
